// ======================== TUTORIELS PORTAIL RH ========================
export const TUTORIELS_RH = [
    {
        id: "rh-decouverte",
        titre: "Bienvenue — Tour du portail",
        description: "Découvrez votre espace de travail RH en 2 minutes",
        icon: "🎓",
        duree: "2 min",
        niveau: "Débutant",
        portail: "RH",
        steps: [
            {
                target: "body",
                placement: "center",
                title: "Bienvenue dans le portail RH AVH 👋",
                content: "Ce tour rapide va vous présenter les 5 espaces principaux de votre portail. Vous pourrez le relancer à tout moment depuis le menu Aide.",
                disableBeacon: true,
            },
            {
                target: "[data-tour='nav-approbations']",
                title: "Approbations",
                content: "Ici vous validez les demandes de congés et les signalements des salariés. Le chiffre entre parenthèses indique le nombre d'éléments en attente.",
            },
            {
                target: "[data-tour='nav-planning']",
                title: "Planning",
                content: "Vue calendrier de toutes les absences. Vous pouvez filtrer par service, par équipe, ou rechercher une personne. C'est votre écran central pour voir qui est présent.",
            },
            {
                target: "[data-tour='nav-salaries']",
                title: "Salariés",
                content: "L'annuaire complet de l'AVH. Vous y trouverez : l'annuaire, les demandes de changement (nom, poste...), la fiche individuelle, et les badgeages.",
            },
            {
                target: "[data-tour='nav-approbateurs']",
                title: "Approbateurs",
                content: "Définissez qui est N+1 et N+2 dans chaque service. C'est essentiel pour que le workflow de validation fonctionne.",
            },
            {
                target: "[data-tour='nav-administration']",
                title: "Administration",
                content: "Paramètres de l'application, jours fériés, gestion des rôles, et le nouvel onglet de Dépannage pour diagnostiquer les problèmes.",
            },
            {
                target: "body",
                placement: "center",
                title: "C'est tout pour le tour ! 🎉",
                content: "Vous êtes prête. Vous trouverez d'autres tutoriels dans le menu Aide & Formation pour apprendre chaque fonction en détail.",
            },
        ],
    },
    {
        id: "rh-valider-conge",
        titre: "Valider une demande de congé",
        description: "Un salarié a posé un congé. Voyons comment l'approuver ou la refuser.",
        icon: "✅",
        duree: "3 min",
        niveau: "Débutant",
        portail: "RH",
        scenario: "Céline a posé 5 jours de CP en juillet. Votre rôle : vérifier que ça ne crée pas de trou dans le service et valider.",
        navigation: { targetView: "approbations" },
        steps: [
            {
                target: "body",
                placement: "center",
                title: "Scénario",
                content: "Céline CASAR a posé 5 jours de congés payés en juillet. Vous devez vérifier qu'il n'y a pas de conflit avec d'autres absences dans son service, puis valider ou refuser.",
                disableBeacon: true,
            },
            {
                target: "[data-tour='tab-conges']",
                title: "Onglet Demandes de congés",
                content: "Toutes les demandes en attente apparaissent ici. Le nombre entre parenthèses vous dit combien sont à traiter.",
            },
            {
                target: "[data-tour='filtre-statut']",
                title: "Filtrer par statut",
                content: "Pour aller plus vite, filtrez sur 'En attente' pour ne voir que ce qui vous demande une action.",
            },
            {
                target: "[data-tour='ligne-conge']",
                title: "Une ligne = une demande",
                content: "Cliquez sur les icônes verte (approuver) ou rouge (refuser) à la fin de la ligne. Avant de valider, jetez un œil au planning pour vérifier les conflits !",
            },
            {
                target: "body",
                placement: "center",
                title: "Astuce",
                content: "Avant de valider une longue absence, ouvrez un second onglet sur 'Planning' et vérifiez les chevauchements avec les collègues du même service.",
            },
        ],
    },
    {
        id: "rh-badge-oublie",
        titre: "Gérer un oubli de badge",
        description: "Un salarié vous appelle : il a oublié son badge. Comment corriger ?",
        icon: "🏷️",
        duree: "2 min",
        niveau: "Débutant",
        portail: "RH",
        scenario: "Paul vous appelle à 9h15 : 'J'ai oublié mon badge ce matin, je suis arrivé à 8h30'. Vous devez ajouter son pointage manuellement.",
        navigation: { targetView: "salaries" },
        steps: [
            {
                target: "body",
                placement: "center",
                title: "Scénario réel",
                content: "Un salarié vous dit qu'il est arrivé à 8h30 mais qu'il a oublié son badge. Vous allez saisir son entrée manuellement dans son tableau de badgeages.",
                disableBeacon: true,
            },
            {
                target: "[data-tour='tab-badgeages']",
                title: "Onglet Badgeages",
                content: "Cet onglet est votre outil principal pour consulter et corriger les pointages individuels.",
            },
            {
                target: "[data-tour='peoplepicker']",
                title: "Rechercher le salarié",
                content: "Tapez les premières lettres du nom. La recherche est instantanée dans l'annuaire AVH.",
            },
            {
                target: "[data-tour='btn-saisir-badgeage']",
                title: "Bouton 'Saisir un badgeage'",
                content: "Cliquez sur ce bouton pour ouvrir le formulaire de saisie manuelle. Vous pourrez renseigner les horaires et ajouter un motif (ex: 'Oubli badge').",
            },
            {
                target: "body",
                placement: "center",
                title: "Tracabilité",
                content: "Les badgeages saisis manuellement par vous sont marqués 'Manuel' (vs 'Badgeuse' pour la badgeuse physique). Vous pouvez à tout moment voir la différence.",
            },
        ],
    },
    {
        id: "rh-anomalie-badgeage",
        titre: "Anomalies de badgeage",
        description: "Comprendre les alertes automatiques générées par le système",
        icon: "⚠️",
        duree: "3 min",
        niveau: "Intermédiaire",
        portail: "RH",
        scenario: "Le système envoie automatiquement des alertes aux salariés qui ont oublié de badger. Voici comment ça marche.",
        steps: [
            {
                target: "body",
                placement: "center",
                title: "Comment ça marche ?",
                content: "Chaque heure entre 9h et 17h, un script vérifie les badgeages du jour. Si un salarié n'a pas badgé à 11h, ou qu'il lui manque une sortie à 16h, il reçoit un mail automatique.",
                disableBeacon: true,
            },
            {
                target: "body",
                placement: "center",
                title: "Les 4 types d'anomalies",
                content: "Badgeage manquant (pas de pointage), Sortie manquante (entrée sans sortie), Pause midi absente (journée continue sans coupure), Journée trop longue (> 10h).",
            },
            {
                target: "body",
                placement: "center",
                title: "Phase pilote",
                content: "Pour l'instant les alertes ne concernent que 3 personnes (pilotes). Vous pouvez les activer pour tout le monde dans Configuration > 'alertes_badgeage_pilotes' (videz la valeur) et 'alertes_badgeage_actif' = true.",
            },
            {
                target: "body",
                placement: "center",
                title: "Seuils paramétrables",
                content: "Tous les seuils (heure de déclenchement, durée max de journée...) sont dans la liste Configuration. Modifiez 'alertes_seuil_badgeage_manquant' (heure), 'alertes_seuil_pause_midi', 'alertes_seuil_sortie_manquante', 'alertes_seuil_journee_longue_min' (minutes) ou 'alertes_heure_debut'/'alertes_heure_fin' pour adapter au besoin.",
            },
            {
                target: "body",
                placement: "center",
                title: "Exclusions automatiques",
                content: "Le système exclut automatiquement : les weekends, les jours fériés, les salariés en congé/RTT/télétravail approuvés. Pas de fausse alerte !",
            },
            {
                target: "body",
                placement: "center",
                title: "Exclusions manuelles (cadres autonomes)",
                content: "Certains salariés ne badgent pas (cadres autonomes, direction). Ajoutez leurs emails dans la clé 'alertes_badgeage_exclusions' (séparés par virgules) dans Configuration. Ils ne recevront jamais d'alerte.",
            },
        ],
    },
    {
        id: "rh-diagnostic",
        titre: "Diagnostiquer un problème",
        description: "Un salarié se plaint qu'il ne peut pas se connecter : comment investiguer ?",
        icon: "🔍",
        duree: "3 min",
        niveau: "Intermédiaire",
        portail: "RH",
        scenario: "Un salarié vous appelle : 'Je n'arrive pas à accéder au portail, il dit Accès refusé'. Vous devez comprendre pourquoi.",
        navigation: { targetView: "administration" },
        steps: [
            {
                target: "body",
                placement: "center",
                title: "Scénario",
                content: "Un salarié vous signale qu'il est bloqué à l'écran 'Accès refusé'. Vous allez utiliser l'outil de dépannage pour comprendre son statut dans l'application.",
                disableBeacon: true,
            },
            {
                target: "[data-tour='tab-depannage']",
                title: "Onglet Dépannage",
                content: "Cet onglet contient tous les outils de diagnostic. L'état général du système est affiché en haut.",
            },
            {
                target: "[data-tour='search-user']",
                title: "Diagnostiquer un utilisateur",
                content: "Tapez l'email du salarié et cliquez 'Rechercher'. Vous verrez son statut dans la liste des rôles et dans Azure AD (compte actif, attribut Salarié, etc.).",
            },
            {
                target: "body",
                placement: "center",
                title: "Interprétation",
                content: "Si 'Aucun rôle explicite' + extensionAttribute1 ≠ 'Salarié' = c'est normal, bénévole/générique. Si 'accountEnabled: false' = compte désactivé. Sinon il faut creuser.",
            },
            {
                target: "[data-tour='runbook']",
                title: "Procédures de dépannage",
                content: "En bas de page, des procédures pas-à-pas pour les cas les plus fréquents. Toujours commencer par là.",
            },
        ],
    },
    {
        id: "rh-creer-compte",
        titre: "Demander la création d'un compte",
        description: "Nouveau salarié ? Soumettez une demande de création de compte en 4 étapes.",
        icon: "🆕",
        duree: "3 min",
        niveau: "Débutant",
        portail: "RH",
        scenario: "Une nouvelle salariée arrive lundi au service Comptabilité. Vous allez préparer son compte AD/Entra.",
        navigation: { targetView: "salaries" },
        steps: [
            {
                target: "body",
                placement: "center",
                title: "Création de comptes",
                content: "Ce module remplace les anciens tickets manuels. Vous saisissez la demande, l'IT valide, et le compte est créé automatiquement quelques minutes plus tard.",
                disableBeacon: true,
            },
            {
                target: "[data-tour='tab-creation']",
                title: "Onglet Nouveau compte",
                content: "Toutes les demandes de création de compte passent par ici. Vous voyez celles à approuver, celles en file et celles déjà créées.",
            },
            {
                target: "[data-tour='btn-nouvelle-demande']",
                title: "Lancer le wizard",
                content: "Cliquez ici pour ouvrir le formulaire en 4 étapes. Comptez environ 1 minute pour le remplir.",
            },
            {
                target: "body",
                placement: "center",
                title: "Étape 1 — Identité",
                content: "Prénom, nom, date d'arrivée. L'UPN est généré automatiquement (1ère lettre du prénom + nom, sans accent) et reste modifiable.",
            },
            {
                target: "body",
                placement: "center",
                title: "Étape 2 — Classification",
                content: "Catégorie (Salarié/Bénévole/...), lieu (Siège/Comité/...), service et type machine. Ces champs déterminent les groupes DSG et l'OU AD.",
            },
            {
                target: "body",
                placement: "center",
                title: "Étape 3 — Hiérarchie",
                content: "Manager via PeoplePicker, téléphone, bureau, fonction. Le manager est important : c'est lui qui validera les futurs congés.",
            },
            {
                target: "body",
                placement: "center",
                title: "Étape 4 — Licences & récap",
                content: "La licence O365 est pré-sélectionnée selon le lieu (SPB pour Siège, Basic pour Comité). Vérifiez le récap puis soumettez.",
            },
            {
                target: "body",
                placement: "center",
                title: "Approbation IT",
                content: "L'IT reçoit un mail, examine la demande, peut éditer chaque champ, puis approuve ou refuse. Une fois approuvée, le script AVHDC2 crée le compte dans la minute.",
            },
        ],
    },
];
// ======================== TUTORIELS PORTAIL SALARIE ========================
export const TUTORIELS_SALARIE = [
    {
        id: "salarie-bienvenue",
        titre: "Bienvenue sur votre espace personnel",
        description: "Votre nouveau portail en 1 minute",
        icon: "👋",
        duree: "1 min",
        niveau: "Débutant",
        portail: "Salarie",
        steps: [
            {
                target: "body",
                placement: "center",
                title: "Bienvenue ! 👋",
                content: "Ce portail est votre espace personnel. Vous pouvez y poser vos congés, consulter vos horaires, voir votre parcours et contacter les RH.",
                disableBeacon: true,
            },
            {
                target: "[data-tour='nav-dashboard']",
                title: "Tableau de bord",
                content: "Vue d'ensemble de vos congés : combien vous en avez posés, combien sont validés, combien sont en attente.",
            },
            {
                target: "[data-tour='nav-absences']",
                title: "Mes absences",
                content: "Posez une demande de congés ici. Vous verrez aussi l'historique de toutes vos demandes et leur statut.",
            },
            {
                target: "[data-tour='nav-badgeage']",
                title: "Mes badgeages",
                content: "Consultez vos horaires de la semaine. Si vous êtes badgeant(e), vos horaires s'affichent automatiquement depuis la badgeuse.",
            },
            {
                target: "[data-tour='nav-infos']",
                title: "Mes informations",
                content: "Vos coordonnées personnelles. Vous pouvez demander un changement (adresse, téléphone...) qui sera traité par les RH.",
            },
            {
                target: "[data-tour='nav-aide']",
                title: "Aide & contact",
                content: "Besoin d'aide ? Contactez les RH directement depuis cette page.",
            },
            {
                target: "body",
                placement: "center",
                title: "Vous êtes prêt·e ! 🚀",
                content: "Commencez par jeter un œil à votre tableau de bord. Si vous avez des questions, vous pouvez relancer ce tour à tout moment depuis le menu Aide.",
            },
        ],
    },
    {
        id: "salarie-poser-conge",
        titre: "Poser une demande de congés",
        description: "Apprenez à demander vos vacances en 4 étapes",
        icon: "🏖️",
        duree: "2 min",
        niveau: "Débutant",
        portail: "Salarie",
        navigation: { targetView: "absences" },
        steps: [
            {
                target: "body",
                placement: "center",
                title: "Poser une demande",
                content: "Vous voulez partir en vacances ou poser un RTT ? Voyons comment faire en 4 étapes simples.",
                disableBeacon: true,
            },
            {
                target: "[data-tour='btn-nouvelle-demande']",
                title: "Nouvelle demande",
                content: "Cliquez sur ce bouton pour ouvrir le formulaire.",
            },
            {
                target: "body",
                placement: "center",
                title: "Choisissez le type",
                content: "CP (congés payés), RTT, Sans solde, etc. Si vous hésitez, demandez aux RH.",
            },
            {
                target: "body",
                placement: "center",
                title: "Dates et durée",
                content: "Sélectionnez la période. Pour une demi-journée, cochez l'option. Le nombre de jours ouvrés est calculé automatiquement (weekends et jours fériés exclus).",
            },
            {
                target: "body",
                placement: "center",
                title: "Envoi et validation",
                content: "Cliquez sur 'Envoyer'. Votre responsable (N+1) reçoit une notification par email et peut approuver ou refuser. Vous serez notifié·e de sa décision.",
            },
        ],
    },
    {
        id: "salarie-consulter-badgeage",
        titre: "Consulter mes horaires",
        description: "Comprendre l'affichage de vos badgeages",
        icon: "⏰",
        duree: "2 min",
        niveau: "Débutant",
        portail: "Salarie",
        navigation: { targetView: "badgeage" },
        steps: [
            {
                target: "body",
                placement: "center",
                title: "Vos badgeages",
                content: "Cette page affiche vos horaires de la semaine. Si vous badgez physiquement, les données arrivent automatiquement depuis la badgeuse.",
                disableBeacon: true,
            },
            {
                target: "body",
                placement: "center",
                title: "Navigation entre semaines",
                content: "Utilisez les flèches ‹ › en haut du tableau pour changer de semaine. Vous pouvez consulter l'historique complet.",
            },
            {
                target: "body",
                placement: "center",
                title: "Badges Badgeuse / Déclaratif",
                content: "Une ligne bleue = badgeuse physique (lecture seule). Une ligne blanche = saisie manuelle (par vous ou les RH). Vous ne pouvez pas modifier les badgeages de la badgeuse physique.",
            },
            {
                target: "body",
                placement: "center",
                title: "Cumul hebdomadaire",
                content: "En bas du tableau, votre total d'heures de la semaine. Un moyen simple de vérifier que vous êtes bien dans votre quota.",
            },
            {
                target: "body",
                placement: "center",
                title: "Un problème ?",
                content: "Si vous voyez une anomalie (oubli, mauvais horaire), contactez les RH via l'onglet 'Aide & contact'. Ils peuvent corriger les badgeages manuellement.",
            },
        ],
    },
    {
        id: "salarie-changer-infos",
        titre: "Demander un changement d'info",
        description: "Nouvelle adresse, nouveau téléphone ? Voici la procédure",
        icon: "📝",
        duree: "1 min",
        niveau: "Débutant",
        portail: "Salarie",
        navigation: { targetView: "infos" },
        steps: [
            {
                target: "body",
                placement: "center",
                title: "Changement d'information",
                content: "Vous avez déménagé ? Changé de téléphone ? Cette page vous permet de demander la mise à jour de vos coordonnées.",
                disableBeacon: true,
            },
            {
                target: "body",
                placement: "center",
                title: "Onglet 'Demander un changement'",
                content: "Sélectionnez ce que vous voulez modifier (adresse, téléphone, email personnel...) et entrez la nouvelle valeur. Un motif peut être demandé.",
            },
            {
                target: "body",
                placement: "center",
                title: "Traitement",
                content: "Votre demande est envoyée aux RH. Elle est traitée dans les 48h en moyenne. Vous recevrez une confirmation par email une fois le changement effectif.",
            },
            {
                target: "body",
                placement: "center",
                title: "Historique",
                content: "Toutes vos demandes passées sont visibles en bas de la page, avec leur statut (en attente, traitée, refusée).",
            },
        ],
    },
];
export function getTutorielById(id) {
    return [...TUTORIELS_RH, ...TUTORIELS_SALARIE].find((t) => t.id === id);
}
